<template>
	<div class="home">
		<van-nav-bar fixed title="标题" left-text="返回" right-text="按钮" left-arrow placeholder />
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" :head-height="100">
			<div class="goods">
				<nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isGoodsLoading" :threshold="200">
					<div v-for="(item, index) in CouponData" :key="index" class="activity-card">
						<div class="activity-info">
							<p>{{ index }}</p>
						</div>
					</div>
				</nut-infiniteloading>
			</div>
		</van-pull-refresh>

		<nut-backtop :distance="400"></nut-backtop>
	</div>
</template>

<script>
export default {
	name: 'activityLink',
	data() {
		return {
			isLoading: false,
			CouponData: [],
			page: 1,
			num: 30,
			isHasMore: true,
			isGoodsLoading: false
		};
	},
	created() {
		this.loadData();
	},

	methods: {
		onRefresh() {
			this.isLoading = true;
			this.page = 1;
			this.loadData();
		},
		loadData() {
			this.isGoodsLoading = true;
			this.$Request.post('product/goodslist', { page: this.page, source: 'home', limit: 20 }).then(res => {
				this.isLoading = false;
				this.isGoodsLoading = false;
				if (res.code == 200) {
					res.data.forEach(item => {
						this.CouponData.push(item);
					});
				} else {
					this.isHasMore = false;
				}
			});
		},
		onInfinite() {
			this.page = this.page + 1;
			this.loadData();
		},
		detail(e) {
			suni.showLoading();
			suni.navigateTo({
				url: '/pages/detail/goodsinfo?itemid=' + e.itemid + '&goods_type=' + e.shopType
			})
				.then(res => {
					suni.hideLoading();
				})
				.catch(err => {
					suni.hideLoading();
					suni.showToast({
						title: JSON.stringify(err),
						success: err => {
							console.log(err);
						}
					});
				});
		}
	}
};
</script>
<style>
body {
	background-color: #f8f8f8;
}
.home-header {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 100;
}
.home .van-pull-refresh {
	margin-top: 4px;
}
.activity-card {
	width: 95%;
	margin: 0 auto;
	background-color: #ffffff;
	border-radius: 5px;
	margin-bottom: 10px;
}
.activity-info {
	padding: 10px;
}
</style>
